import { render, staticRenderFns } from "./PixComparativoPeriodo.vue?vue&type=template&id=6bb4db2e"
import script from "./PixComparativoPeriodo.vue?vue&type=script&lang=ts"
export * from "./PixComparativoPeriodo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports